// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.

import { Capacitor } from "@capacitor/core";

/**
 * Status bar style options.
 * - "Dark": Dark text for light backgrounds
 * - "Light": Light text for dark backgrounds
 * - "Default": Platform default style
 */
export type StatusBarStyleType = "Dark" | "Light" | "Default";

/**
 * Sets the status bar style (text/icon color).
 * On native platforms, updates the device status bar.
 * On web, this is a no-op.
 *
 * @param style - The style to apply ("Dark", "Light", or "Default")
 */
export async function setStatusBarStyle(style: StatusBarStyleType): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style[style] });
  } catch {
    // StatusBar plugin may not be available in test environment
  }
}
